// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"02730b7c","lsc":"36c765dc","others":"0c9e57de"}[chunkId] + ".chunk.js";
};